<template>
    <flex-container
        align-items="center"
        inline
        justify-content="space-between"
        no-wrap
    >
        <span>
            {{ truncatedText }}
        </span>
        <button-text v-if="truncatedText.length < props.text.length" @click="modal?.openOverlay()">
            <span>
                Lees meer
            </span>
            <svg-icon
                :icon="ChevronIcon"
                :size="IconSize.md"
                :color="'primary'"
                is-custom-icon
            />
        </button-text>

        <modal-dialog
            ref="modal"
            :size="3"
            :description="props.text"
            label="Lees meer"
        >
            <flex-container>
                <text-heading>
                    Comment
                </text-heading>
                <div style="width: 100%">
                    {{ props.text }}
                </div>
                <button-block @loading="modal?.closeOverlay(); $event.button.setState(ButtonState.completed)">
                    Sluiten
                </button-block>
            </flex-container>
        </modal-dialog>
    </flex-container>
</template>

<script setup lang="ts">
    import { ButtonState, type ExposedOverlay, IconSize } from '@keyvue/one-ui';
    import ChevronIcon from '@keyvue/one-awesome-icons/icons/regular/chevron-right.svg?component';
    import { computed, ref } from 'vue';

    const props = defineProps<{
        text: string
    }>();

    const truncatedText = computed(() => {
        if (props.text.length > 50) {
            return `${props.text.substring(0, 47)}...`;
        }

        return props.text;
    });

    const modal = ref<ExposedOverlay>();
</script>
